import { Context } from '@nuxt/types'
import { PromiseAll } from '~/assets/ts/utils/misc'

export default async function ({ store }: Context) {
  await PromiseAll([
    store.dispatch('site/fetchDisplayAds'),
    store.dispatch('webcasts/fetchBoostedWebcasts'),
    store.dispatch('misc/getSaStats'),
  ])
}
